



























































































import FormPayment from '@/app/shared/components/forms/payment.vue';
import { InstallmentModel, VForm } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { FormPayment } })
export default class DialogInstallmentEditComponent extends Vue {
  @Ref() private form!: VForm;
  @Prop(Boolean) readonly value!: boolean;

  private valueTab = '';
  private installment: InstallmentModel = new InstallmentModel();
  private dueDateMenu = false;

  private get refs() {
    return refsService;
  }
  private get installmentOriginalDueDate(): string {
    const dateNow = this.refs.moment().format('YYYY-MM-DD');
    return dateNow < this.refs.modules.contract.installmentOriginalDueDate
      ? dateNow
      : this.refs.modules.contract.installmentOriginalDueDate;
  }
  private get rules() {
    return this.refs.static.rules;
  }

  private async saveInstallment() {
    if (this.form && !this.form.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    if (this.form && this.form.validate()) {
      const installmentId = this.installment.Id;
      if (installmentId === undefined) return;

      const installment: InstallmentModel = new InstallmentModel();
      installment.OriginalDueDate = this.installment.OriginalDueDate;
      const data = {
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: installmentId,
        installment: installment,
        descReason: this.valueTab,
      };
      await this.refs.modules.contract
        .updateInstallment(data)
        .then(async () => {
          this.$toast(this.$t('toasts.change_installment_successfully'));
          this.refs.modules.ticket.SET_EDIT_INSTALLMENT(true);
          await this.refs.modules.contract.loadInstallmentList(
            this.$route.params.id
          );
          this.$emit('close');
        })
        .catch((err) => {
          this.refs.util.showErrors(err);
        });
    }
  }

  @Watch('value')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value && this.form) this.form.resetValidation();
    if (value) {
      const installmentId = this.refs.modules.contract.installment.Id;
      if (installmentId === undefined) return;
    }
    this.installment = this.refs._.clone(
      this.refs.modules.contract.installment
    );
  }
}
